import classnames from "classnames/bind";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styles from "./index.css";
import {
  hideFilterOverlay,
  toggleSecondaryList
} from "../../state/modules/layout/actions";
import {
  getFilterOverlayVisible,
  getSecondaryListIsOpen
} from "../../state/modules/layout/selectors";
import { analyticsRefinementsCloseMobile } from "../../state/modules/analytics/actions";
import TrapFocus from "../../components/TrapFocus";
import Escapable from "../../components/Escapable";

const styleContext = classnames.bind(styles);

export const FilterLayout = ({
  isFilterOverlayVisible,
  hideFilterOverlay,
  toggleSecondaryList,
  secondaryListIsOpen,
  analyticsRefinementsCloseMobile,
  children
}) => {
  const layout = styleContext({
    filterLayout: true,
    showOnMobile: isFilterOverlayVisible
  });

  const handleClick = () => {
    if (isFilterOverlayVisible) {
      hideFilterOverlay();
      if (secondaryListIsOpen) {
        toggleSecondaryList();
      }
      analyticsRefinementsCloseMobile();
    }
  };

  return (
    <aside className={styles.container}>
      <Escapable escapeHandler={handleClick} />
      <div className={layout}>
        <div
          className={styles.grayTapArea}
          onClick={handleClick}
          aria-hidden={true}
        />
        <TrapFocus
          className={styles.filterContainer}
          trapFocus={isFilterOverlayVisible}
        >
          {children}
        </TrapFocus>
      </div>
    </aside>
  );
};

FilterLayout.propTypes = {
  children: PropTypes.node.isRequired,
  hideFilterOverlay: PropTypes.func.isRequired,
  toggleSecondaryList: PropTypes.func.isRequired,
  secondaryListIsOpen: PropTypes.bool.isRequired,
  analyticsRefinementsCloseMobile: PropTypes.func.isRequired,
  isFilterOverlayVisible: PropTypes.bool.isRequired
};

FilterLayout.displayName = "FilterLayout";

/* istanbul ignore next */
const mapDispatchToProps = {
  hideFilterOverlay,
  analyticsRefinementsCloseMobile,
  toggleSecondaryList
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    isFilterOverlayVisible: getFilterOverlayVisible(state),
    secondaryListIsOpen: getSecondaryListIsOpen(state)
  };
}

const FilterLayoutContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterLayout);

export default FilterLayoutContainer;
